import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(
	({ spacing, breakpoints }) => ({
		root: {
			padding: ({ isTypeResultPdf }) => (isTypeResultPdf ? spacing(6) : 0),
		},
		grid: {
			width: `calc(100% + ${spacing(6)})`,
			margin: spacing(-3),
			[breakpoints.down('sm')]: {
				width: `calc(100% + ${spacing(4)})`,
				margin: spacing(-2),
			},
		},
		skeleton: {
			borderRadius: 4,
		},
		rectWrap: {
			display: 'flex',
			justifyContent: ({ isTypeResultPdf }) => (isTypeResultPdf ? 'center' : 'flex-end'),
			[breakpoints.down('sm')]: {
				justifyContent: 'center !important',
			},
		},
		rect: {
			width: '100%',
			maxWidth: spacing(50),
			alignSelf: 'flex-end',
			height: 'auto',
			aspectRatio: 1,
		},
	}),
	{ name: 'WithLazy-Fallback' },
)

export default useStyles
